const ACCESS_LABEL_OVERRIDES = {
    "Researcher Access Service": "Research Data Access Pathway",
};

export function getAccessLabel(value) {
    return ACCESS_LABEL_OVERRIDES[value] ?? value;
}

export function renderTagSelection(tagQuerySelection) {
    let tagListSelected = "";

    tagQuerySelection.forEach(tag => {
        tagListSelected += `
        <li class="mb-3 flex items-start font-medium">
            <input type="checkbox"
                id="tag-select-${tag.Normalized}"
                value="${tag.Distinct}"
                class="peer absolute h-8 w-8 opacity-0 js-filter-selected-checkbox js-filter-checkbox"
                data-id="tags-${tag.Distinct}"
                checked />
            <div class="mr-2 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md border border-blue-800 bg-white text-transparent peer-checked:bg-green-200 peer-checked:text-blue-800 peer-focus:border-2 peer-focus:border-green-600">
                <svg class="pointer-events-none h-5 w-5 fill-none"
                        viewBox="0 0 22 15"
                        xmlns="http://www.w3.org/2000/svg">
                    <path class="stroke-current"
                            d="M1 8.58333L6.88235 14L21 1"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"></path>
                </svg>
            </div>
            <label for="tag-select-${tag.Normalized}" class="select-none">${tag.Distinct}</label>
        </li>
        `
    })

    return tagListSelected;
}

export function renderOrgSelection(orgQuerySelection) {
    let orgListSelected = "";

    orgQuerySelection.forEach(org => {
        orgListSelected += `
        <li class="mb-3 flex items-start font-medium">
            <input type="checkbox"
                id="org-select-${org.result.Normalized}"
                value="${org.result.Distinct}"
                class="peer absolute h-8 w-8 opacity-0 js-filter-selected-checkbox js-filter-checkbox"
                data-id="tags-${org.result.Normalized}"
                checked />
            <div class="mr-2 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md border border-blue-800 bg-white text-transparent peer-checked:bg-green-200 peer-checked:text-blue-800 peer-focus:border-2 peer-focus:border-green-600">

                <svg class="pointer-events-none h-5 w-5 fill-none"
                        viewBox="0 0 22 15"
                        xmlns="http://www.w3.org/2000/svg">
                    <path class="stroke-current"
                            d="M1 8.58333L6.88235 14L21 1"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"></path>
                </svg>
            </div>
            <label for="org-select-${org.result.Normalized}" class="select-none">${titleCase(org.result.Distinct)}</label>
        </li>
        `
    });

    return orgListSelected;
}

export function renderAccessSelection(accessQuerySelection) {
    let accessListSelected = "";

    accessQuerySelection.forEach(access => {
        accessListSelected += `
        <li class="mb-3 flex items-start font-medium">
            <input type="checkbox"
                id="access-select-${access.Normalized}"
                value="${access.Distinct}"
                class="peer absolute h-8 w-8 opacity-0 js-filter-selected-checkbox js-filter-checkbox"
                data-id="tags-${access.Distinct}"
                checked />
            <div class="mr-2 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md border border-blue-800 bg-white text-transparent peer-checked:bg-green-200 peer-checked:text-blue-800 peer-focus:border-2 peer-focus:border-green-600">
                <svg class="pointer-events-none h-5 w-5 fill-none"
                        viewBox="0 0 22 15"
                        xmlns="http://www.w3.org/2000/svg">
                    <path class="stroke-current"
                            d="M1 8.58333L6.88235 14L21 1"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"></path>
                </svg>
            </div>
            <label for="access-select-${access.Normalized}" class="select-none">${getAccessLabel(access.Distinct)}</label>
        </li>
        `
    })

    return accessListSelected;
}

export function titleCase(str) {
    return str.toLowerCase().split(' ').map(function (word) {
        let labelTitleCase = word.charAt(0).toUpperCase() + word.slice(1);
        labelTitleCase = (labelTitleCase === "Of") ? "of" : labelTitleCase;
        labelTitleCase = (labelTitleCase === "Dataloch") ? "DataLoch" : labelTitleCase;
        labelTitleCase = (labelTitleCase === "(dash)") ? "(DaSH)" : labelTitleCase;
        return labelTitleCase;
    }).join(' ');
}